import "./loaderStyles.scss";

const Loader = () => (
  <div className="wrap-loader">
    <div className="loader loader-butterfly"></div>
    <div className="loader-message">Loading...</div>
  </div>
);

export default Loader;
